import { render, staticRenderFns } from "./slipBlock.vue?vue&type=template&id=73f920fe&scoped=true&"
import script from "./slipBlock.ts?vue&type=script&lang=ts&"
export * from "./slipBlock.ts?vue&type=script&lang=ts&"
import style0 from "./slipBlock.vue?vue&type=style&index=0&id=73f920fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f920fe",
  null
  
)

export default component.exports